




















































































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {Paystub} from "@/dto/payroll/PayrollDTO";
import PayrollReportControlPanelModal
	from "@/components/payroll/reports/PayrollReportControlPanelModal.vue";
import Application from "@/state/Application";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import {prettyEnum} from "@/utils/StringUtils";

@Component
export default class PaystubReportView extends Vue {

	@Prop()
	private report!: Paystub

}

